module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/46.6ffe4a38.png";